import { Injectable } from '@angular/core';
import { isNotUndefined } from 'lib/helpers/array.utils';
import { DialogService } from 'lib/ui/dialog';
import { SimpleTableImage, SimpleTableItem } from 'lib/ui/simple-table';
import { IImage } from 'lib/ui/ui-models';

@Injectable({ providedIn: 'root' })
export class ExerciseUtilsService {
	constructor(private readonly dialogService: DialogService) {}

	openExerciseInstructionDialog(exercise: {
		readonly images: readonly IImage[];
		readonly name: string;

		readonly equipment?: string;
		readonly categories?: readonly string[];
		readonly videoUrl?: string;
		readonly source?: string;
		readonly instructions?: string;
		readonly targetMuscleGroup?: string;
		readonly forceType?: string;
		readonly laterality?: string;
		readonly difficulty?: string;
	}): void {
		const instructionTableItems: SimpleTableItem[] = [];

		if (exercise.images.length) {
			instructionTableItems.push({
				title: 'Images',
				valueType: 'text',
				value: undefined,
				images: exercise.images
					.map((image) => {
						const tableImage: SimpleTableImage = {
							image: image,
							title: image.originalImage.filename
						};

						return tableImage;
					})
					.filter(isNotUndefined)
			});
		}
		if (exercise?.difficulty) {
			instructionTableItems.push({
				title: 'Difficulty',
				valueType: 'text',
				value: exercise.difficulty
			});
		}

		if (exercise?.equipment) {
			instructionTableItems.push({
				title: 'Equipment',
				valueType: 'text',
				value: exercise.equipment
			});
		}
		if (exercise?.targetMuscleGroup) {
			instructionTableItems.push({
				title: 'Target muscle group',
				valueType: 'text',
				value: exercise.targetMuscleGroup
			});
		}
		if (exercise?.forceType) {
			instructionTableItems.push({
				title: 'Force type',
				valueType: 'text',
				value: exercise.forceType
			});
		}
		if (exercise?.laterality) {
			instructionTableItems.push({
				title: 'Laterality',
				valueType: 'text',
				value: exercise.laterality
			});
		}
		if (exercise?.categories?.length) {
			instructionTableItems.push({
				title: 'Categories',
				valueType: 'text',
				value: exercise.categories.join(', ')
			});
		}
		if (exercise?.videoUrl) {
			instructionTableItems.push({
				title: 'Video url',
				valueType: 'text',
				value: exercise.videoUrl,
				externalUrl: exercise.videoUrl
			});
			instructionTableItems.push({
				title: 'Video',
				valueType: 'text',
				value: undefined,
				videoUrl: exercise.videoUrl
			});
		}

		this.dialogService.openTextDialog({
			subtitle: 'Instructions',
			title: exercise.name,
			text: exercise.instructions,
			tableItems: instructionTableItems
		});
	}
}
